`<template lang="pug">
  div
    changes-header(:extraField="extraField")
      record-changes-wrap(
        v-for='(data, i) in tableData.data'
        :key='i'
        :changesData="data")

    .show-more__btn(v-if="showButton")
      show-more(@show-more="showModal")

</template>

<script>
import { mapActions, mapMutations, } from 'vuex'
import { TOGGLE_CHANGES_MODAL, CHANGE_MODIFICATION_TYPE, } from '@/store/modules/record/mutations-types'

import ShowMore from '@/components/record-details/ShowMore'
import ChangesHeader from '@/components/record-details/modifications/ChangesHeader'
import RecordChangesWrap from '@/components/record-details/modifications/RecordChangesWrap'


export default {
  name: 'RecordChangesBlock',
  components: {
    RecordChangesWrap,
    ChangesHeader,
    ShowMore,
  },
  props: {
    tableData: {
      type: Object,
      default: () => {},
    },
    extraField: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      currentPage: 1,
      lastPage: 1,
    }
  },
  computed: {
    modificationType () {
      return this.tableData.type
    },
    showButton () {
      return this.currentPage < this.lastPage
    },
  },
  mounted () {
    this.parsePagination(this.tableData)
  },
  methods: {
    showModal () {
      this.toggleModal({ show: true, })
      this.changeModificationType(this.modificationType)
    },
    parsePagination (data) {
      this.lastPage = data.pagination.lastPage
      this.currentPage = data.pagination.currentPage
    },

    ...mapActions('record', [ 'getRecordModifications', ]),
    ...mapMutations('record', {
      toggleModal: TOGGLE_CHANGES_MODAL,
      changeModificationType: CHANGE_MODIFICATION_TYPE,
    }),
  },
}
</script>

<style scoped lang="stylus">
  .show-more__btn
    margin-top: 20px
</style>



// WEBPACK FOOTER //
// src/components/record-details/modifications/RecordChangesBlock.vue